import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8v3a1 1 0 0 0 1 1h3","key":"svg-0"}],["path",{"d":"M18 8v8","key":"svg-1"}],["path",{"d":"M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3","key":"svg-2"}]]

const IconNumber94Small = createReactComponent('outline', 'number-94-small', 'Number94Small', __iconNode);

export default IconNumber94Small;